import Cursor from './modules/Cursor';
import Footer from './modules/Footer';
import Header from './modules/Header';
// import Preloader from './modules/Preloader';
import HomePage from './pages/HomePage';
import { Routes, Route } from 'react-router-dom';
import ProjectDetail from './pages/ProjectDetail';
import NotFoundPage from './pages/NotFoundPage';
import PhoneCallButton from './modules/PhoneCallButton';
import WhatsAppButton from './modules/WhatsAppButton';


function App() {
  return (
    <div className="App">
      {/* <Preloader /> */}
      <PhoneCallButton/>
      <WhatsAppButton/>
      <Header />
      <Routes>
      <Route path="/" element={ <HomePage />} />
      <Route path="/projects/:slug" element={<ProjectDetail />} />
      <Route path="*" element={<NotFoundPage />} /> Catch-all route for 404

      {/* <Route path="/about" element={<About />} /> */}
    </Routes>
      <Cursor />
      <Footer />
    </div>
  );
}

export default App;
